import { Modal } from '@sgcmpteltd/uikit-next';
import cx from 'clsx';

import { MODAL_TRANSITION_DURATION_MS_DEFAULT } from './constants';
import styles from './styles.module.scss';
import type { Component, ContentList } from './types';

export const TermsAndConditionsModal: Component = ({
  termsContentList,
  isOpen,
  transitionDurationMs = MODAL_TRANSITION_DURATION_MS_DEFAULT,
  onClose,
}) => {
  const contentList: ContentList = termsContentList.map((string, index) => ({ // @suppress longLineCheck
    key: `terms-and-conditions-${index}`,
    content: string,
  }));

  return (
    <Modal
      className={cx(
        styles.containerRoot,
        styles.hasCustomizedTitle,
        styles.isMediumModal,
      )}
      contentClassName={cx(
        styles.containerModalContent,
        styles.hasWidePadding,
        styles.isCentralContent,
      )}
      isOpen={isOpen}
      title=""
      transitionDurationMs={transitionDurationMs}
      onClose={onClose}>
      <div className={styles.textModalTitle}>Terms & Conditions</div>
      <ul className={styles.containerListContent}>
        {contentList.map(item => (
          <li
            key={item.key}
            className={styles.textTerms}>
            {item.content}
          </li>
        ))}
      </ul>
    </Modal>
  );
};
